import moment from "moment";
import React from "react";
import { Button, DatePicker } from "react-unity";

interface DateRangePickerProps {
    fromDateOnChangeFunction: any,
    toDateOnChangeFunction: any
    fromDateValue: any,
    toDateValue: any,
    containerStyle?: any,
    pickerStyle?: any
}

const DateRangePicker = (props: DateRangePickerProps) => {
    return (
        <Button.Group style={props.containerStyle}>	
            <DatePicker
                name="datepicker-example"
                label="From Date"
                onChange={(e) => props.fromDateOnChangeFunction(e)}
                value={ props.fromDateValue ? moment(props.fromDateValue).format('YYYY-MM-DD') : ''}
                placeholder='YYYY-MM-DD'
                style={props.pickerStyle}
            />
            <DatePicker
                name="datepicker-example"
                label="To Date"
                onChange={(e) => props.toDateOnChangeFunction(e)}
                value={props.toDateValue ? moment(props.toDateValue).format('YYYY-MM-DD') : ''}
                placeholder='YYYY-MM-DD'
                style={props.pickerStyle}
            />
        </Button.Group>
    )
}

export default DateRangePicker;